export default "__VITE_ASSET__CX3RhbQq__"